<template>
    <div :class="{ 'nav-open': $sidebar.showSidebar }">
        <notifications transition-name="notification-list" transition-mode="out-in"> </notifications>
        <router-view name="header"></router-view>
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
        <router-view name="footer"></router-view>
    </div>
</template>

<script>
// Loading some plugin css asynchronously
import 'sweetalert2/dist/sweetalert2.css'
import 'vue-notifyjs/themes/default.css'
export default {}
</script>
<style lang="scss">
$color-hybrid: #99e354;
$color-sativa: #e15f0f;
$color-indica: #6054e3;
a:hover {
    text-decoration: none;
}
span.type-hybrid {
    border-color: $color-hybrid;
    background-color: $color-hybrid;
}
span.type-sativa {
    border-color: $color-sativa;
    background-color: $color-sativa;
}
span.type-indica {
    border-color: $color-indica;
    background-color: $color-indica;
}
.d-flex,
.flex-grow {
    flex: 1;
}
.el-table div.cell {
    min-height: 1.5rem;
    word-break: break-word;
}
.span-addon-right {
    padding-left: 10px;
}
.span-addon-left {
    padding-right: 10px;
}
.hint {
    font-weight: 400;
    color: #9a9a9a;
    font-size: 0.7142em;
}
.card .card-footer button.btn,
.card .card-footer a.btn {
    margin: 2px 1px;
}
form .col-xl-6 {
    margin-bottom: 0.5rem;
}
/*!
     * Animation retrieved from:
     * animate.css -http://daneden.me/animate
     * Version - 3.5.1
     * Licensed under the MIT license - http://opensource.org/licenses/MIT
     *
     * Copyright (c) 2016 Daniel Eden
     */
@keyframes rubberBand {
    from {
        -webkit-transform: scale3d(1, 1, 1);
        transform: scale3d(1, 1, 1);
    }

    30% {
        -webkit-transform: scale3d(1.25, 0.75, 1);
        transform: scale3d(1.25, 0.75, 1);
    }

    40% {
        -webkit-transform: scale3d(0.75, 1.25, 1);
        transform: scale3d(0.75, 1.25, 1);
    }

    50% {
        -webkit-transform: scale3d(1.15, 0.85, 1);
        transform: scale3d(1.15, 0.85, 1);
    }

    65% {
        -webkit-transform: scale3d(0.95, 1.05, 1);
        transform: scale3d(0.95, 1.05, 1);
    }

    75% {
        -webkit-transform: scale3d(1.05, 0.95, 1);
        transform: scale3d(1.05, 0.95, 1);
    }

    to {
        -webkit-transform: scale3d(1, 1, 1);
        transform: scale3d(1, 1, 1);
    }
}

.rubberBand {
    -webkit-animation-name: rubberBand;
    animation-name: rubberBand;
}
</style>
